import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardLayoutComponent} from 'src/app/shared/layout/dashboard-layout/component/dashboard-layout.component';
import {accessTokenGuard} from "../../core/guards/access-token.guard";
import {EAccessType} from "../../core/enums/access-type.enum";


const routes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [accessTokenGuard],
    data: {allowedAccessToken: EAccessType.FAT,},
    children: [
      {
        path: 'admin-users',
        loadChildren: () =>
          import('./modules/admin-users/admin-users.module').then(
            (m) => m.AdminUsersModule
          ),
      },
      {
        path: 'admin-roles',
        loadChildren: () =>
          import('./modules/admin-roles/admin-roles.module').then(
            (m) => m.AdminRolesModule
          ),
      },
       {
        path: 'interest-rate-bracket',
        loadChildren: () =>
          import('./modules/interest-rate-bracket/interest-rate-bracket.module').then(
            (m) => m.InterestRateBracketModule
          ),
      },
    ]

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {
}
